export default {"src":"/_next/static/media/zoho_allblue.161cc328.svg","height":11,"width":32,"blurWidth":0,"blurHeight":0};